export default __webpack_public_path__ + "static/media/g5.85482c85.PNG";